<template>
  <a href="/2010/poster.jpg" target="_blank">
    <img
      src="/2010/poster_sample.jpg"
      alt="VIZBI 2010 conference poster"
      class="poster"
      title="Click here to download the VIZBI 2010 conference poster" />
  </a>
  <p>
    VIZBI 2010 was held March 3&ndash;5 at the
    <a href="http://www.embl.de/">EMBL</a> in Heidelberg, Germany. This workshop &mdash; the first
    of its kind &mdash; reviewed the state-of-the-art and challenges in visualizing data from
    genomes, transcripts, proteins, cells, organisms, and populations.
  </p>
  <p>
    <a href="https://www.embo.org/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./Sponsors/img/embo.png"
        alt="EMBO"
        title="EMBO"
        class="inline-logo" />
      <img v-else src="./Sponsors/img/embo-darkMode.png" alt="EMBO" title="EMBO" class="inline-logo" />
    </a>
    <a href="http://www.embl.de/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./Sponsors/img/embl.png"
        alt="EMBL"
        title="EMBL"
        class="inline-logo" />
      <img v-else src="./Sponsors/img/embl-darkMode.png" alt="EMBL" title="EMBL" class="inline-logo" />
    </a>
  </p>
</template>

<script setup>
import {inject} from "vue";
const displayMode = inject("displayMode");
</script>

<style scoped>
img.poster {
  float: right;
  margin: 0 0 12px 12px;
  max-width: 240px;
  width: 35%;
  height: auto;
}
img.inline-logo {
  height: 3rem;
  width: auto;
  vertical-align: middle;
  margin-right: 12px;
}
</style>
